export type SpreadsheetFileVisualProps = {
  width?: number;
};

export function SpreadsheetFileVisual({
  width
}: SpreadsheetFileVisualProps): JSX.Element {
  const w = width || 48;
  const h = width || 48;
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Spreadsheet file icon"
      role="img"
    >
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint0_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint1_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint2_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint3_linear_1551_55868)"
        fill-opacity="0.13"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint4_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint5_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint6_radial_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint7_radial_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint8_radial_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint9_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint10_linear_1551_55868)"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint11_linear_1551_55868)"
        fill-opacity="0.55"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint12_linear_1551_55868)"
        fill-opacity="0.55"
      />
      <path
        d="M28.4148 11.3359C28.2272 11.1483 27.9729 11.043 27.7077 11.043H14.4391C13.6659 11.043 13.0391 11.6698 13.0391 12.443V37.557C13.0391 38.3302 13.6659 38.957 14.4391 38.957H33.5609C34.3341 38.957 34.9609 38.3302 34.9609 37.557V18.2962C34.9609 18.031 34.8556 17.7767 34.668 17.5891L28.4148 11.3359Z"
        fill="url(#paint13_linear_1551_55868)"
      />
      <path
        d="M26.9549 11.457C26.9549 11.2556 27.0127 11.0854 26.9031 11.0639C27.0073 11.0705 27.8785 10.9883 27.9722 11.0976C28.0955 11.146 28.0214 11.3427 28.1179 11.4369C28.1207 11.4397 28.1235 11.4424 28.1263 11.4452L34.3795 17.6985C34.3986 17.7176 34.4168 17.7373 34.4342 17.7577C34.5195 17.858 34.5635 17.8361 34.6036 17.9601C34.6355 18.0587 34.8646 17.8545 34.8646 17.9601L34.9415 18.1137V18.3281C34.9415 18.3281 34.9896 18.5789 34.8646 18.5789L28.3922 19.3002C27.3644 19.3002 26.3965 18.1188 26.3965 17.4561L26.9549 11.457Z"
        fill="url(#paint14_linear_1551_55868)"
      />
      <path
        d="M26.9549 11.457C26.9549 11.2556 27.0127 11.0854 26.9031 11.0639C27.0073 11.0705 27.8785 10.9883 27.9722 11.0976C28.0955 11.146 28.0214 11.3427 28.1179 11.4369C28.1207 11.4397 28.1235 11.4424 28.1263 11.4452L34.3795 17.6985C34.3986 17.7176 34.4168 17.7373 34.4342 17.7577C34.5195 17.858 34.5635 17.8361 34.6036 17.9601C34.6355 18.0587 34.8646 17.8545 34.8646 17.9601L34.9415 18.1137V18.3281C34.9415 18.3281 34.9896 18.5789 34.8646 18.5789L28.3922 19.3002C27.3644 19.3002 26.3965 18.1188 26.3965 17.4561L26.9549 11.457Z"
        fill="url(#paint15_linear_1551_55868)"
      />
      <path
        d="M26.9549 11.457C26.9549 11.2556 27.0127 11.0854 26.9031 11.0639C27.0073 11.0705 27.8785 10.9883 27.9722 11.0976C28.0955 11.146 28.0214 11.3427 28.1179 11.4369C28.1207 11.4397 28.1235 11.4424 28.1263 11.4452L34.3795 17.6985C34.3986 17.7176 34.4168 17.7373 34.4342 17.7577C34.5195 17.858 34.5635 17.8361 34.6036 17.9601C34.6355 18.0587 34.8646 17.8545 34.8646 17.9601L34.9415 18.1137V18.3281C34.9415 18.3281 34.9896 18.5789 34.8646 18.5789L28.3922 19.3002C27.3644 19.3002 26.3965 18.1188 26.3965 17.4561L26.9549 11.457Z"
        fill="url(#paint16_linear_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint17_linear_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint18_linear_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint19_linear_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint20_linear_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint21_radial_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint22_radial_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint23_radial_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint24_radial_1551_55868)"
      />
      <path
        d="M28.0391 11.3476C28.0391 11.1462 27.8811 11.0665 27.7715 11.0449C27.8756 11.0516 27.9774 11.0744 28.0732 11.1121C28.1965 11.1604 28.31 11.2333 28.4065 11.3275C28.4093 11.3302 28.4121 11.333 28.4149 11.3358L34.6681 17.5891C34.6872 17.6081 34.7054 17.6279 34.7227 17.6483C34.8081 17.7486 34.8723 17.8643 34.9124 17.9882C34.9443 18.0868 34.961 18.1906 34.961 18.2962V18.3593C34.961 18.1271 34.793 17.9882 34.6681 17.9882H29.2391C28.5764 17.9882 28.0391 17.4509 28.0391 16.7882V11.3476Z"
        fill="url(#paint25_radial_1551_55868)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 23H29C29.5523 23 30 23.4477 30 24V25H18V24C18 23.4477 18.4477 23 19 23ZM17 26V25V24C17 22.8954 17.8954 22 19 22H29C30.1046 22 31 22.8954 31 24V33C31 34.1046 30.1046 35 29 35H19C17.8954 35 17 34.1046 17 33V29V28V26ZM18 33V29H23.5V34H19C18.4477 34 18 33.5523 18 33ZM24.5 34H29C29.5523 34 30 33.5523 30 33V29H24.5V34ZM24.5 28H30V26H24.5V28ZM23.5 26H18V28H23.5V26Z"
        fill="url(#paint26_linear_1551_55868)"
      />
      <line x1="17" y1="31.5" x2="30" y2="31.5" stroke="#9A95A1" />
      <defs>
        <linearGradient
          id="paint0_linear_1551_55868"
          x1="24"
          y1="11.043"
          x2="24"
          y2="38.957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EBE4F3" />
          <stop offset="1" stop-color="#E4DAF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1551_55868"
          x1="24"
          y1="11.1698"
          x2="24"
          y2="11.4034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F3F0F6" />
          <stop offset="1" stop-color="#F3F0F6" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1551_55868"
          x1="34.9609"
          y1="24.308"
          x2="34.6187"
          y2="24.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F3F0F6" />
          <stop offset="1" stop-color="#F3F0F6" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1551_55868"
          x1="35.1897"
          y1="24.308"
          x2="34.7872"
          y2="24.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9A6CC" />
          <stop offset="1" stop-color="#B9A6CC" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1551_55868"
          x1="12.22"
          y1="24.308"
          x2="13.2206"
          y2="24.3099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1551_55868"
          x1="25.5191"
          y1="39.4889"
          x2="25.5191"
          y2="38.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </linearGradient>
        <radialGradient
          id="paint6_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.6204 39.1415) rotate(-72.992) scale(0.519149 1.6851)"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.1766 38.7561) rotate(-60.2552) scale(0.470877 1.52842)"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0014 38.2479) rotate(-38.6597) scale(0.336577 1.0925)"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint9_linear_1551_55868"
          x1="12.5881"
          y1="37.5747"
          x2="13.2868"
          y2="37.5747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1551_55868"
          x1="12.2719"
          y1="11.3118"
          x2="13.5771"
          y2="11.8788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5B0BB" />
          <stop offset="1" stop-color="#B5B0BB" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1551_55868"
          x1="12.5025"
          y1="23.9251"
          x2="13.5123"
          y2="23.9251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9A6CC" />
          <stop offset="1" stop-color="#B9A6CC" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1551_55868"
          x1="24"
          y1="38.957"
          x2="24"
          y2="38.7195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9A6CC" />
          <stop offset="1" stop-color="#B9A6CC" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1551_55868"
          x1="34.4103"
          y1="38.7849"
          x2="34.2656"
          y2="38.5156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9A6CC" />
          <stop offset="1" stop-color="#B9A6CC" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1551_55868"
          x1="29.3043"
          y1="13.9341"
          x2="27.5877"
          y2="13.9341"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.72" stop-color="#D2C5DE" />
          <stop offset="1" stop-color="#D2C5DF" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1551_55868"
          x1="31.7242"
          y1="20.2269"
          x2="31.7119"
          y2="17.9618"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.72" stop-color="#E9E1F3" />
          <stop offset="1" stop-color="#E9E1F3" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1551_55868"
          x1="28.4836"
          y1="17.262"
          x2="26.7876"
          y2="19.9196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E9E1F3" stop-opacity="0" />
          <stop offset="0.682292" stop-color="#E9E1F3" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1551_55868"
          x1="28.5391"
          y1="17.707"
          x2="31.1797"
          y2="15.0663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D9D3E1" />
          <stop offset="1" stop-color="#CCC7D1" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1551_55868"
          x1="31.7735"
          y1="14.5507"
          x2="31.1329"
          y2="15.1757"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119171" stop-color="#DBDADC" />
          <stop offset="0.577307" stop-color="#CBC7D0" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1551_55868"
          x1="28.0157"
          y1="13.7483"
          x2="28.1634"
          y2="13.7483"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A19CA7" />
          <stop offset="1" stop-color="#9D9CA7" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1551_55868"
          x1="31.3662"
          y1="18.0351"
          x2="31.3662"
          y2="17.832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C0ACD5" />
          <stop offset="1" stop-color="#C0ACD5" stop-opacity="0" />
        </linearGradient>
        <radialGradient
          id="paint21_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.8847 18.0981) rotate(-81.1582) scale(0.369824 2.14157)"
        >
          <stop stop-color="#C0ACD5" />
          <stop offset="1" stop-color="#C0ACD5" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.3244 17.822) rotate(-40.8602) scale(0.341752 1.97901)"
        >
          <stop stop-color="#A19CA7" />
          <stop offset="1" stop-color="#A19CA7" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.034 17.5043) rotate(-24.7752) scale(0.336783 1.95023)"
        >
          <stop stop-color="#A19CA7" />
          <stop offset="1" stop-color="#A19CA7" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.8378 17.157) rotate(-6.45541) scale(0.422175 2.44472)"
        >
          <stop stop-color="#A19CA7" />
          <stop offset="1" stop-color="#A19CA7" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint25_radial_1551_55868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.4666 17.8859) rotate(-59.8587) scale(0.275483 1.59526)"
        >
          <stop stop-color="#A19CA7" />
          <stop offset="1" stop-color="#A19CA7" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint26_linear_1551_55868"
          x1="17"
          y1="34.3546"
          x2="26.0399"
          y2="34.3546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9C96A2" />
          <stop offset="1" stop-color="#9A95A1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
